import React from "react";

import { Card, Spinner } from "@bps/fluent-ui";
import { SettingsLabels } from "@modules/settings/screens/shared-components/SettingsLabels.ts";
import { BookingTenantSettings } from "@stores/booking/models/BookingTenantSettings.ts";
import { RootStore } from "@stores/root/RootStore.ts";
import {
  DataFetcher,
  withFetch
} from "@ui-components/data-fetcher/DataFetcher.tsx";

import { BookingTenantSettingsForm } from "./components/BookingTenantSettingsForm.tsx";

const cardStyles = {
  subComponentStyles: {
    tile: {
      content: {
        padding: 0
      }
    }
  }
};

const CommunicationSettingsCardBase: React.FC = React.memo(() => {
  const getTenantSettings = async ({
    booking
  }: RootStore): Promise<BookingTenantSettings | undefined> => {
    return await booking.getTenantSettings();
  };

  return (
    <Card
      iconName="Megaphone"
      headingLevel="section-heading"
      heading={SettingsLabels.communications}
      styles={cardStyles}
    >
      <DataFetcher fetch={getTenantSettings} fallback={<Spinner />}>
        {() => <BookingTenantSettingsForm />}
      </DataFetcher>
    </Card>
  );
});

export const CommunicationSettingsCard = withFetch(
  x => [
    x.core.ref.australianStates.load(),
    x.core.ref.timeZones.load(),
    x.clinical.getClinicalActivitiesPreferenceByTenant(),
    x.clinical.loadActivityDescriptions({
      activityType: ["RMDR"],
      ignoreCache: true
    })
  ],
  CommunicationSettingsCardBase
);
